var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100"},[(_vm.isSitemap)?_c('sitemap'):(_vm.screenData.url)?_c('sf-iframe',{attrs:{"url":_vm.screenData.url,"screenParam":{ scrId: _vm.screenData.scrId },"iframeParam":_vm.userInfo},on:{"load":_vm.load}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }